/* eslint-disable */
const $ = require('jquery');
require('jquery-validation');
require('jquery-validation-unobtrusive');

$.validator.addMethod('enforcetrue', (value, element, param) => element.checked);
$.validator.unobtrusive.adapters.addBool('enforcetrue');

$.validator.addMethod('emailstrict', (value, element, param) => value.match(emailRegex));
$.validator.unobtrusive.adapters.addBool('emailstrict');

/**
 * Based on regex provided by source, test string to be a valid date, also considering leap years.
 * Provided regex expects forward slash, so in case dashes are used, replace dashes with forward slash.
 * Source: https://stackoverflow.com/a/33530009
 * @param {String} str ie '21-01-1986'
 * @returns {Boolean}
 */
const stringDateIsValid = function(str) {
	str.replace('-', '/'); // Regex expects forward slash
	var dateRegex = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
	return dateRegex.test(str);
};

/**
 * Convert a string, ie output of input.value, to a valid date.
 * @param {String} str ie '21-01-1986'
 * @returns {Date}
 */
const stringDateToDate = function(str) {
	let retval = str.split('-');
	const d = retval[0];
	const m = retval[1];
	const y = retval[2];
	return new Date(y, m, d);
};

// ////////////////////////////////////////////////////////////------start date picker--------///////////////////////////////////////////////////////

const dateBox = document.querySelectorAll('.js-date');

dateBox.forEach(item => {
	const day = item.querySelector('.js-day');
	const month = item.querySelector('.js-month');
	const year = item.querySelector('.js-year');
	const fullDate = item.querySelector('.js-full-date');

	let timeout;

	function validateForm() {
		const d = day.value;
		const m = month.value;
		const y = year.value;

		fullDate.value = d.length > 0 || m.length > 0 || y.length > 0 ? `${d}-${m}-${y}` : '';

		clearTimeout(timeout);
		timeout = setTimeout(() => {
			$(fullDate).valid();
		}, 300);
		return true;
	}
	day.addEventListener('keyup', validateForm);
	month.addEventListener('keyup', validateForm);
	year.addEventListener('keyup', validateForm);
});
$.validator.addMethod('datefuture', (value, element, param) => {
	let result = false; // Default validation is invalid

	if (element.previousElementSibling){
		value = new Date(element.previousElementSibling.value).toLocaleDateString('nl-NL');
	}
	const futureStamp = new Date(element.dataset.ruleDatefutureStamp).toLocaleDateString('nl-NL');
	
	// Check if date is valid, else don't continue
	if (
		!!element.dataset.ruleDatefutureStamp &&
		stringDateIsValid(futureStamp) &&
		stringDateIsValid(value)
	) {
		const dateFuture = stringDateToDate(futureStamp);
		const dateUser = stringDateToDate(value); // Note that value is equal to element.value
		// Check if date is in expected range (lt future)
		if (dateUser < dateFuture) {
			result = true;
		}
	}

	return result;
});
$.validator.addMethod('datemin', (value, element, param) => {
	let result = false; // Default validation is invalid
	
	if (element.previousElementSibling){
		value = new Date(element.previousElementSibling.value).toLocaleDateString('nl-NL');
	}
	const minStamp = new Date(element.dataset.ruleDateminStamp).toLocaleDateString('nl-NL');
	
	// Check if date is valid, else don't continue
	if (
		!!element.dataset.ruleDateminStamp &&
		stringDateIsValid(minStamp) &&
		stringDateIsValid(value)
	) {
		const dateMin = stringDateToDate(minStamp);
		const dateUser = stringDateToDate(value); // Note that value is equal to element.value
		// Check if date is in expected range (gte min)
		if (dateUser >= dateMin) {
			result = true;
		}
	}

	return result;
});
$.validator.addMethod('datemax', (value, element, param) => {
	let result = false; // Default validation is invalid
	
	if (element.previousElementSibling){
		value = new Date(element.previousElementSibling.value).toLocaleDateString('nl-NL');
	}
	const maxStamp = new Date(element.dataset.ruleDatemaxStamp).toLocaleDateString('nl-NL');
	
	// Check if date is valid, else don't continue
	if (
		!!element.dataset.ruleDatemaxStamp &&
		stringDateIsValid(maxStamp) &&
		stringDateIsValid(value)
	) {
		const dateMax = stringDateToDate(maxStamp);
		const dateUser = stringDateToDate(value); // Note that value is equal to element.value
		// Check if date is in expected range (lt max)
		if (dateUser < dateMax) {
			result = true;
		}
	}

	return result;
});
$.validator.addMethod('date', (value, element, param) => {
	// Check if date is valid
	
	if (element.previousElementSibling){
		value = new Date(element.previousElementSibling.value).toLocaleDateString('nl-NL');
	}
	return stringDateIsValid(value);
});

// /////////////////////////////////////////////////////--------end date picker----------////////////////////////////////////////////////////////////

$.validator.addMethod('thisorthat', (value, element, param) => {
	const self = $(element);
	const that = $(param);
	return (
		(self.val().length > 0 && that.val().length === 0) || // This has value, and that does not
		(that.val().length > 0 && self.val().length === 0) || // That has value, and this does not
		(self.val().length === 0 && that.val().length === 0) // Neither this or that has value
	);
});
$.validator.unobtrusive.adapters.addBool('thisorthat');

$.validator.addMethod('coupled', (value, element, param) => {
	const self = $(element);
	const that = $(param);
	return (
		(that.val().length > 0 && self.val().length > 0) || // This and that have value: good!
		(that.val().length === 0 && self.val().length > 0) // Only this has value: good!
	);
});
$.validator.unobtrusive.adapters.addBool('coupled');

const formValidation = function() {
	// Source: "Wait for User to Stop Typing, Using JavaScript | Gregory Schier" https://schier.co/blog/2014/12/08/wait-for-user-to-stop-typing-using-javascript.html
	let inputValidationTimeout = null;
	const inputValidationKeyupFunction = function(element, event) {
		const keycode = event.keyCode ? event.keyCode : event.charCode;
		// ignore all special keys except backspace
		if (
			(keycode >= 48 && keycode <= 90) ||
			(keycode >= 96 && keycode <= 111) ||
			(keycode >= 186 && keycode <= 192) ||
			(keycode >= 219 && keycode <= 222) ||
			keycode == 8 ||
			keycode == 46
		) {
			clearTimeout(inputValidationTimeout);
			inputValidationTimeout = setTimeout(() => {
				$(element).valid();
			}, 500);
		}
	};

	$('.js-validate').each(function() {
		if(!$(this).data('validator')){ return; }

		const settings = $(this).data('validator').settings;
		const oldErrorFunction = settings.errorPlacement;
		settings.errorClass = 'help';
		settings.onkeyup = inputValidationKeyupFunction;
		settings.ignore = '.js-ignore-validation, :hidden';
		settings.highlight = function(element, errorClass, validClass) {
			$(element)
				.closest('.field')
				.addClass('is-error')
				.removeClass('is-success');
		};
		settings.unhighlight = function(element, errorClass, validClass) {
			$(element)
				.closest('.field')
				.removeClass('is-error')
				.addClass('is-success');
		};
		settings.errorPlacement = function(error, inputElement) {
			const control = $(inputElement).closest('.control');
			error.insertAfter(control);
			oldErrorFunction(error, inputElement);
		};
	});

	// scroll to umbraco-forms thankyou page if posted
	if ($('.umbraco-forms-submitmessage').length > 0) {
		$(document).scrollTop(
			$('.umbraco-forms-submitmessage')
				.closest('section')
				.position().top - 200
		);
	}
	// scroll to umbraco-forms validation errors if posted
	if ($('.umbraco-forms-form .field-validation-error').length > 0) {
		$(document).scrollTop(
			$('.umbraco-forms-form .field-validation-error')
				.closest('section')
				.position().top - 200
		);
	}
};

module.exports = formValidation;
